import React from 'react'
import { Link } from 'react-router-dom'
import Iframe from 'react-iframe'
import bg25 from '../../assets/images/background/bg-25.png'
import bg6 from '../../assets/images/background/bg-6.png'
import restro from '../../assets/images/resource/restaurant-pizza.jpg'

function Contactbanner() {
    return (
        <>
            <div className="contact-map">
                <Iframe src="https://maps.google.com/maps?q=Ivana%20Gunduli%C4%87a%207%2C%20Smederevo%20230437&t=&z=15&ie=UTF8&iwloc=&output=embed" width="100%" height="500" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></Iframe>
            </div>

            <section className="contact-page">
                <div className="left-bg"><img src={bg25} alt="" title="" /></div>
                <div className="right-bg"><img src={bg6} alt="" title="" /></div>

                <div className="location-center">
                    <div className="auto-container">
                        <div className="cinfo-box">
                            <div className="row clearfix">

                                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                                    <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="300ms">
                                        <h4>Radno Vreme</h4>
                                        <div className="text">Ponedeljak - Subota <br /> 08:00 - 22:30</div>
                                    </div>
                                </div>

                                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                                    <div className="inner-box cp-seprator wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="300ms">
                                        <h4>Kontakt Info</h4>
                                        <div className="text">Ivana Gundulića 7, Smederevo 230437</div>
                                        <div className="more-link"><Link to="tel:+381641856290">Naručivanje: +381 64 1856 290</Link></div>
                                    </div>
                                </div>

                                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                                    <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="600ms">
                                        <h4>Nedelja</h4>
                                        <div className="text">Zatvoreno</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="auto-container">
                    <div className="c-page-form-box">
                        <div className="row clearfix">

                            <div className="loc-block col-lg-6 col-md-12 col-sm-12">
                                <div className="title-box centered">
                                    <h2>Kontaktirajte Nas</h2>
                                    <div className="text desc">Imate pitanje ili želite da naručite? Tu smo za vas!</div>
                                </div>
                                <div className="contact-info-box">
                                    <div className="info-item">
                                        <h4>Telefon</h4>
                                        <p><a href="tel:+381641856290">+381 64 1856 290</a></p>
                                        <div className="text">Pozovite nas za narudžbine i informacije</div>
                                    </div>
                                    
                                    <div className="info-item">
                                        <h4>Adresa</h4>
                                        <p>Ivana Gundulića 7, lokal 1</p>
                                        <p>Smederevo 230437</p>
                                    </div>
                                    
                                    <div className="info-item">
                                        <h4>Radno Vreme</h4>
                                        <p>Ponedeljak - Subota: 08:00 - 22:30</p>
                                        <p>Nedelja: Zatvoreno</p>
                                    </div>
                                    
                                    <div className="info-item">
                                        <h4>Naručite Online</h4>
                                        <div className="more-link">
                                            <a href="https://glovoapp.com/rs/en/smederevo/bon-appetit-smd/" target="_blank" rel="noopener noreferrer">Glovo</a> <br/>
                                            <a href="https://wolt.com/sr/srb/smederevo/restaurant/bon-appetit-smederevo?srsltid=AfmBOoqrxFzCZCweBtLFJjMRJEOyTajPItBmoEv6whAbOqG2XbhA_dsD" target="_blank" rel="noopener noreferrer">Wolt</a>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>


                            <div className="loc-block col-lg-6 col-md-12 col-sm-12">
                                <img src={restro} alt="" />
                            </div>

                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default Contactbanner